/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-splash.js
 *
 * ロード後に実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

var body = document.body;
var scale = document.querySelectorAll(".splash-scale");
var stamp = document.querySelectorAll(".splash-stamp");
var scaleUpfadeIN = document.querySelectorAll(".splash-scaleUpfadeIN");
var dot = document.querySelectorAll(".mv-copy .dot");
var willChangeItem = document.querySelectorAll(".hintBrowser");

/**
 * hintBrowser
 * will-changeを付け外し
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function hintBrowser() {
  for (let i = 0; i < willChangeItem.length; i++) {
    willChangeItem[i].classList.remove("hintBrowser");
  }
}

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set(body, {
  opacity: 0,
});
gsap.set(scale, {
  scale: 2,
  opacity: 0
});
gsap.set(stamp, {
  scale: 1.5,
  opacity: 0
});
gsap.set(dot, {
  scale: 2,
  opacity: 0
});
gsap.set(scaleUpfadeIN, {
  scale: 0.8,
  opacity: 0
});

/**
 * timeline
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

var tl = gsap.timeline({
  defaults: { duration: 1, ease: "power4.out" },
});

/**
 * to
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * actionToSplashHome
 * TOPページ用スプラッシュアクション
 * 
 * LP A
 */
function actionToSplashHome() {
  tl.to(body, {
    opacity: 1,
  }).to(scaleUpfadeIN, {
    scale: 1,
    opacity: 1,
  },"<").to(dot, {
    scale: 1,
    opacity: 1,
    stagger: {
      from: "start",
      amount: 0.2,
    },
  });
}

/**
 * actionToSplashHome
 * TOPページ用スプラッシュアクション
 * 
 * LP B
 */
// function actionToSplashHome() {
//   tl.to(body, {
//     opacity: 1,
//   }).to(scale, {
//     scale: 1,
//     opacity: 1,
//   }).to(stamp, {
//     scale: 1,
//     opacity: 1,
//     duration: 0.5,
//   });
// }

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { actionToSplashHome, hintBrowser };
